module.exports = __webpack_public_path__ + "img/vip-coupon-btn-bg.497150f9.png";